/* unplugin-vue-components disabled */import script from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlay.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlay.vue?vue&type=style&index=0&id=4c3ce0c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c3ce0c8"]])

export default __exports__